module.exports = __webpack_public_path__ + "static/cover-6ebd35473d1ed4a59dcc1f34a4adc28f.jpg";